'use client';

import { getGameDownloadUrl } from '@/features/games/shared/helpers/get-game-download-url';
import { isWtGamesAppUserAgent } from '@/features/games-app-bridge/shared/helpers/is-wt-games-app-user-agent';
import { useOverlayStore } from '@/shared/components/overlay/overlay.store';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

export const PLAY_GAME_MODAL_KEY = 'play-game';

export const startGameDownload = (sku: string, isTrialDownload = false): void => {
  if (isTrialDownload) {
    emitGTMEvent('GAME_TRIAL_DOWNLOAD_STARTED');
  }

  const isGamesApp = isWtGamesAppUserAgent(
    typeof navigator === 'undefined' ? null : navigator.userAgent,
  );

  if (!isGamesApp) {
    useOverlayStore.getState().showOverlay(PLAY_GAME_MODAL_KEY);
  }

  window.location.assign(getGameDownloadUrl(sku, isGamesApp));
};
